import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { Person as PersonIcon } from '@mui/icons-material';

const ReportTile = ({ title, onClick }) => {
  return (
    <Paper
      sx={{
        p: 2,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          backgroundColor: 'grey.100',
          borderRadius: 1,
          p: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <PersonIcon sx={{ fontSize: 40, color: 'primary.main' }} />
      </Box>
      <Typography 
        variant="body1" 
        sx={{ 
          fontWeight: 400
        }}
      >
        {title}
      </Typography>
    </Paper>
  );
};

export default ReportTile;
